module.exports = __webpack_public_path__ + "static/media/personal.316dc01f.jpeg";